module.exports = __webpack_public_path__ + "img/1561638472.e7178d4b.jpg";